import styled, { css } from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { theme } from '../../../styles/theme';
import { SvgIcon } from '../../Icon';
import { toggleCommentMode } from '../../../redux/slices/conversationThreads';
import { HEADER_Z_INDEX } from '../../../styles/zIndexes';
import { AnalyticsHtmlButton } from '../../Button';

const Container = styled.div`
  z-index: ${HEADER_Z_INDEX};
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  column-gap: 16px;
  padding: 8px;
  border-radius: 8px;
  box-shadow: ${theme.effects.shadow2};
  background-color: ${theme.colors.level2};
`;

const ActionContainer = styled(AnalyticsHtmlButton)<{ $isActive: boolean }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 4px;
  color: ${theme.colors.secondary900};
  &:hover {
    cursor: pointer;
    background-color: ${theme.colors.mainBlue};
    color: ${theme.colors.white};
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: ${theme.colors.mainBlue};
      color: ${theme.colors.white};
    `}
`;

const FloatingToolbar = () => {
  const dispatch = useAppDispatch();
  const isCommentMode = useAppSelector(
    (state) => state.conversationThreads.isCommentMode,
  );
  const isCommentingDisabled = useAppSelector(
    (state) => state.conversationThreads.isCommentingDisabled,
  );

  const handleToggleCommentMode = () => {
    dispatch(toggleCommentMode());
  };

  if (isCommentingDisabled) {
    return null;
  }

  return (
    <Container>
      <ActionContainer
        type="button"
        onClick={handleToggleCommentMode}
        $isActive={!isCommentMode}
      >
        <SvgIcon
          name="cursor"
          width={24}
          height={24}
          customFill="currentColor"
        />
      </ActionContainer>
      <ActionContainer
        type="button"
        onClick={handleToggleCommentMode}
        $isActive={isCommentMode}
        disabled={isCommentMode}
        trackContext="comments"
        trackAction="enter comment mode"
      >
        <SvgIcon
          name="chat-teardrop"
          width={24}
          height={24}
          customFill="currentColor"
        />
      </ActionContainer>
    </Container>
  );
};

export default FloatingToolbar;
